import React, {useContext, useEffect} from 'react'
import {OfferEditContext} from "../../../context/OfferUpdateContext";
import {Form, InputNumber} from "antd";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";


const OfferUpdateQuantity = ({rowIndex, record}) => {

    const [form] =Form.useForm()
    const {bidContent} = useContext(OfferEditContext)
    const [bidList, setBidList] = bidContent

    useEffect(() => {
        form.setFieldsValue({
            [`quantity-${rowIndex}`]: record.amount
        })
    }, [rowIndex, record])

    const handleChange = ({target}) => {
        const newList = replaceIndexAt(
            bidList,
            {
                ...record,
                amount: target.value
            },
            rowIndex
        )
        setBidList(newList)
    }

    return(
        <React.Fragment>
            <Form form={form}>
                <Form.Item name={`quantity-${rowIndex}`}>
                    <InputNumber onBlur={handleChange} step={0.1} />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferUpdateQuantity